<div class="wrapper">

  <!-- ============ LIST VIEW ============ -->
  <div class="m-box" *ngIf="!editing">
    <h2>{{ 'appointments.gui.questionnaires.Pre-visit Questionnaires' | translate }}</h2>

    <div class="q-list" *ngIf="questionnaires.length; else emptyState">
      <div class="q-list-row" *ngFor="let q of questionnaires">
        <div class="q-list-main">
          <div class="q-list-name">{{ q.name }}</div>
          <div class="q-list-meta">
            <span class="q-badge" *ngIf="examLabel(q)">{{ examLabel(q) }}</span>
            <span class="q-badge q-badge--muted">{{ (q.questions || []).length }} {{ 'appointments.gui.questionnaires.questions' | translate }}</span>
          </div>
        </div>
        <div class="q-list-actions">
          <button class="blue-btn" (click)="editQuestionnaire(q)">{{ 'appointments.gui.questionnaires.Edit' | translate }}</button>
          <button class="orange-btn" (click)="deleteQuestionnaire(q)">{{ 'appointments.gui.questionnaires.Delete' | translate }}</button>
        </div>
      </div>
    </div>
    <ng-template #emptyState>
      <p class="q-empty">{{ 'appointments.gui.questionnaires.No questionnaires yet' | translate }}</p>
    </ng-template>

    <button class="blue-btn" style="margin-top: 1em;" (click)="newQuestionnaire()">
      ＋ {{ 'appointments.gui.questionnaires.New Questionnaire' | translate }}
    </button>

    <!-- Company-provided templates the doctor can copy -->
    <div *ngIf="defaults.length" class="defaults-section">
      <div class="section-title defaults-toggle" (click)="showDefaults = !showDefaults">
        <span class="defaults-toggle-arrow" [class.is-open]="showDefaults">▸</span>
        {{ 'appointments.gui.questionnaires.Templates from Artisan' | translate }}
      </div>
      <div class="q-list" *ngIf="showDefaults">
        <div class="q-list-row" *ngFor="let d of defaults">
          <div class="q-list-main">
            <div class="q-list-name">{{ d.name }}</div>
            <div class="q-default-desc" *ngIf="d.description">{{ d.description }}</div>
            <div class="q-list-meta">
              <span class="q-badge q-badge--muted">{{ (d.questions || []).length }} {{ 'appointments.gui.questionnaires.questions' | translate }}</span>
            </div>
          </div>
          <div class="q-list-actions">
            <button class="blue-btn" (click)="useDefault(d)">{{ 'appointments.gui.questionnaires.Use this template' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============ EDITOR VIEW ============ -->
  <div class="m-box" *ngIf="editing">
    <h2>{{ (editing.AutoIndex == null ? 'appointments.gui.questionnaires.New Questionnaire' : 'appointments.gui.questionnaires.Edit Questionnaire') | translate }}</h2>

    <!-- Questionnaire-level settings, centred as one block above the questions -->
    <div class="editor-meta">

    <!-- Name -->
    <div class="field-row">
      <label class="t-label-top">
        <span class="field-label">{{ 'appointments.gui.questionnaires.Questionnaire Name' | translate }}</span>
        <input class="search-patient-field menstural-field"
               dir="auto"
               [(ngModel)]="editing.name">
      </label>
    </div>

    <!-- Default language (item 3): which language(s) the patient receives -->
    <div class="field-row">
      <label class="t-label-top">
        <span class="field-label">{{ 'appointments.gui.questionnaires.Default language' | translate }}</span>
        <select class="t-select" [(ngModel)]="editing.defaultLanguage">
          <option value="he">{{ 'appointments.gui.questionnaires.Hebrew' | translate }}</option>
          <option value="en">{{ 'appointments.gui.questionnaires.English' | translate }}</option>
          <option value="both">{{ 'appointments.gui.questionnaires.Both' | translate }}</option>
        </select>
      </label>
    </div>

    <!-- Exam types (multi-select) -->
    <div class="field-row">
      <mat-form-field>
        <mat-label [ngClass]="['mat-select-value']">
          {{ 'appointments.gui.questionnaires.Applies to Exam Types' | translate }}
        </mat-label>
        <mat-select [(ngModel)]="editing.examSelection" multiple
                    [ngClass]="['mat-select-value','mat-form-field']">
          <mat-option *ngFor="let e of exams" [value]="examKey(e)" [ngClass]="['mat-select-value']">
            {{ e.examName || e.examType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    </div><!-- /editor-meta -->

    <!-- Questions (draggable) -->
    <div class="section-title">{{ 'appointments.gui.questionnaires.Questions' | translate }}</div>

    <div cdkDropList (cdkDropListDropped)="drop($event)" class="questions-list">
      <div class="question-card" *ngFor="let question of editing.questions; let qi = index; trackBy: trackByIndex"
           cdkDrag>
        <div class="question-header">
          <span class="drag-handle" cdkDragHandle title="Drag to reorder">⠿</span>

          <span class="question-index">{{ qi + 1 }}</span>

          <textarea rows="1" *ngIf="!isContentBlock(question.questionType)"
                    class="search-patient-field menstural-field question-text auto-textarea" dir="auto"
                    [(ngModel)]="question.questionText" (input)="autoGrow($event)"
                    [placeholder]="'appointments.gui.questionnaires.Question text' | translate"></textarea>

          <textarea rows="1" *ngIf="isContentBlock(question.questionType)"
                    class="search-patient-field menstural-field question-text block-text auto-textarea" dir="auto"
                    [(ngModel)]="question.questionText" (input)="autoGrow($event)"
                    [placeholder]="'appointments.gui.questionnaires.Block text placeholder' | translate"></textarea>

          <select class="t-select" [(ngModel)]="question.questionType" (ngModelChange)="onTypeChange(question)">
            <option *ngFor="let t of questionTypes" [value]="t.value">
              {{ t.label | translate }}
            </option>
          </select>

          <label class="t-label-top required-toggle" *ngIf="!isContentBlock(question.questionType)">
            <input type="checkbox" class="custom-check -sq" [(ngModel)]="question.required"/>
            <i class="customInput-display -sq" (dblclick)="question.required = false"></i>
            <span>{{ 'appointments.gui.questionnaires.Required' | translate }}</span>
          </label>

          <button type="button" class="orange-btn q-delete-btn" (click)="removeQuestion(qi)">{{ 'appointments.gui.questionnaires.Delete' | translate }}</button>
        </div>

        <!-- Optional English translation of the question / block text (item 1) -->
        <div class="english-row">
          <textarea rows="1" class="search-patient-field menstural-field auto-textarea" dir="ltr"
                    [(ngModel)]="question.questionTextEng" (input)="autoGrow($event)"
                    [placeholder]="'appointments.gui.questionnaires.Question text (English)' | translate"></textarea>
        </div>

        <!-- Placeholder inserters for opening/closing content blocks -->
        <div class="placeholders-block" *ngIf="isContentBlock(question.questionType)">
          <small class="options-label">{{ 'appointments.gui.questionnaires.Insert placeholder' | translate }}</small>
          <button type="button" class="blue-btn placeholder-btn" *ngFor="let p of placeholders"
                  (click)="insertPlaceholder(question, p.token)">{{ p.label | translate }}</button>
        </div>

        <div class="date-settings-block" *ngIf="isDateType(question.questionType)">
          <label class="t-label-top required-toggle">
            <input type="checkbox" class="custom-check -sq"
                   [checked]="isNoFutureDate(question)"
                   (change)="toggleNoFutureDate(question, $event.target.checked)"/>
            <i class="customInput-display -sq"></i>
            <span>{{ 'appointments.gui.questionnaires.No future date' | translate }}</span>
          </label>
          <label class="t-label-top" *ngIf="!isNoFutureDate(question)">
            <span class="field-label">{{ 'appointments.gui.questionnaires.From date' | translate }}</span>
            <input type="date" class="search-patient-field menstural-field" [(ngModel)]="question.dateMin">
          </label>
          <label class="t-label-top" *ngIf="!isNoFutureDate(question)">
            <span class="field-label">{{ 'appointments.gui.questionnaires.To date' | translate }}</span>
            <input type="date" class="search-patient-field menstural-field" [(ngModel)]="question.dateMax">
          </label>
        </div>

        <div class="prefill-block" *ngIf="canPrefill(question.questionType)">
          <label class="t-label-top">
            <span class="field-label">{{ 'appointments.gui.questionnaires.Prefill from' | translate }}</span>
            <select class="t-select" [(ngModel)]="question.prefillField">
              <option *ngFor="let p of prefillFields" [value]="p.value">{{ p.label | translate }}</option>
            </select>
          </label>
        </div>

        <!-- Answer options for choice-type questions -->
        <div class="options-block" *ngIf="isChoiceType(question.questionType)">
          <small class="options-label">{{ 'appointments.gui.questionnaires.Answer Options' | translate }}</small>
          <div class="option-row" *ngFor="let opt of question.options; let oi = index; trackBy: trackByIndex">
            <textarea rows="1" class="search-patient-field menstural-field auto-textarea" style="width: 320px;" dir="auto"
                      [(ngModel)]="opt.optionText" (input)="autoGrow($event)"
                      [placeholder]="'appointments.gui.questionnaires.Option text' | translate"></textarea>
            <textarea rows="1" class="search-patient-field menstural-field auto-textarea" style="width: 320px;" dir="ltr"
                      [(ngModel)]="opt.optionTextEng" (input)="autoGrow($event)"
                      [placeholder]="'appointments.gui.questionnaires.Option text (English)' | translate"></textarea>
            <label class="t-label-top">
              <span class="field-label">{{ 'appointments.gui.questionnaires.Extra field' | translate }}</span>
              <select class="t-select" [(ngModel)]="opt.freeTextType">
                <option *ngFor="let f of freeTextTypes" [value]="f.value">{{ f.label | translate }}</option>
              </select>
            </label>
            <button type="button" class="arrow-btn" (click)="removeOption(question, oi)">✖</button>
          </div>
          <button type="button" class="blue-btn add-option-btn"
                  (click)="addOption(question)">
            ＋ {{ 'appointments.gui.questionnaires.Add Option' | translate }}
          </button>
        </div>

        <!-- AR-32: repeatable group settings + nested sub-questions -->
        <div class="group-block" *ngIf="isGroupType(question.questionType)">
          <div class="field-row">
            <label class="t-label-top">
              <span class="field-label">{{ 'appointments.gui.questionnaires.group.Count rows from' | translate }}</span>
              <select class="t-select" [(ngModel)]="question.repeatCountFromQuestionKey">
                <option value="">{{ 'appointments.gui.questionnaires.group.Manual (add/remove)' | translate }}</option>
                <option *ngFor="let n of numberQuestionsBefore(question)" [value]="n.questionKey">
                  {{ n.questionText }}
                </option>
              </select>
            </label>
            <label class="t-label-top" *ngIf="!question.repeatCountFromQuestionKey">
              <span class="field-label">{{ 'appointments.gui.questionnaires.group.Starting rows' | translate }}</span>
              <input type="number" min="0" max="20" class="search-patient-field menstural-field" style="width: 80px;"
                     [(ngModel)]="question.minItems">
            </label>
          </div>

          <small class="options-label">{{ 'appointments.gui.questionnaires.group.Sub-questions' | translate }}</small>
          <div cdkDropList (cdkDropListDropped)="dropSub($event, question)" class="questions-list subq-list">
            <div class="question-card subq-card" *ngFor="let sq of question.subQuestions; let sqi = index; trackBy: trackByIndex"
                 cdkDrag>
              <div class="question-header">
                <span class="drag-handle" cdkDragHandle title="Drag to reorder">⠿</span>
                <span class="question-index">{{ sqi + 1 }}</span>

                <textarea rows="1" class="search-patient-field menstural-field question-text auto-textarea" dir="auto"
                          [(ngModel)]="sq.questionText" (input)="autoGrow($event)"
                          [placeholder]="'appointments.gui.questionnaires.Question text' | translate"></textarea>

                <select class="t-select" [(ngModel)]="sq.questionType" (ngModelChange)="onSubTypeChange(sq)">
                  <option *ngFor="let t of subQuestionTypes" [value]="t.value">{{ t.label | translate }}</option>
                </select>

                <label class="t-label-top required-toggle">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="sq.required"/>
                  <i class="customInput-display -sq" (dblclick)="sq.required = false"></i>
                  <span>{{ 'appointments.gui.questionnaires.Required' | translate }}</span>
                </label>

                <button type="button" class="orange-btn q-delete-btn" (click)="removeSubQuestion(question, sqi)">{{ 'appointments.gui.questionnaires.Delete' | translate }}</button>
              </div>

              <div class="english-row">
                <textarea rows="1" class="search-patient-field menstural-field auto-textarea" dir="ltr"
                          [(ngModel)]="sq.questionTextEng" (input)="autoGrow($event)"
                          [placeholder]="'appointments.gui.questionnaires.Question text (English)' | translate"></textarea>
              </div>

              <div class="date-settings-block" *ngIf="isDateType(sq.questionType)">
                <label class="t-label-top required-toggle">
                  <input type="checkbox" class="custom-check -sq"
                         [checked]="isNoFutureDate(sq)"
                         (change)="toggleNoFutureDate(sq, $event.target.checked)"/>
                  <i class="customInput-display -sq"></i>
                  <span>{{ 'appointments.gui.questionnaires.No future date' | translate }}</span>
                </label>
                <label class="t-label-top" *ngIf="!isNoFutureDate(sq)">
                  <span class="field-label">{{ 'appointments.gui.questionnaires.From date' | translate }}</span>
                  <input type="date" class="search-patient-field menstural-field" [(ngModel)]="sq.dateMin">
                </label>
                <label class="t-label-top" *ngIf="!isNoFutureDate(sq)">
                  <span class="field-label">{{ 'appointments.gui.questionnaires.To date' | translate }}</span>
                  <input type="date" class="search-patient-field menstural-field" [(ngModel)]="sq.dateMax">
                </label>
              </div>

              <div class="options-block" *ngIf="isChoiceType(sq.questionType)">
                <small class="options-label">{{ 'appointments.gui.questionnaires.Answer Options' | translate }}</small>
                <div class="option-row" *ngFor="let opt of sq.options; let oi = index; trackBy: trackByIndex">
                  <textarea rows="1" class="search-patient-field menstural-field auto-textarea" style="width: 320px;" dir="auto"
                            [(ngModel)]="opt.optionText" (input)="autoGrow($event)"
                            [placeholder]="'appointments.gui.questionnaires.Option text' | translate"></textarea>
                  <textarea rows="1" class="search-patient-field menstural-field auto-textarea" style="width: 320px;" dir="ltr"
                            [(ngModel)]="opt.optionTextEng" (input)="autoGrow($event)"
                            [placeholder]="'appointments.gui.questionnaires.Option text (English)' | translate"></textarea>
                  <label class="t-label-top">
                    <span class="field-label">{{ 'appointments.gui.questionnaires.Extra field' | translate }}</span>
                    <select class="t-select" [(ngModel)]="opt.freeTextType">
                      <option *ngFor="let f of freeTextTypes" [value]="f.value">{{ f.label | translate }}</option>
                    </select>
                  </label>
                  <button type="button" class="arrow-btn" (click)="removeSubOption(sq, oi)">✖</button>
                </div>
                <button type="button" class="blue-btn add-option-btn" (click)="addSubOption(sq)">
                  ＋ {{ 'appointments.gui.questionnaires.Add Option' | translate }}
                </button>
              </div>
            </div>

            <p class="q-empty" *ngIf="!question.subQuestions.length">
              {{ 'appointments.gui.questionnaires.group.No sub-questions yet' | translate }}
            </p>
          </div>

          <button type="button" class="blue-btn" style="margin-top: 0.6em;" (click)="addSubQuestion(question)">
            ＋ {{ 'appointments.gui.questionnaires.group.Add sub-question' | translate }}
          </button>
        </div>
      </div>

      <p class="q-empty" *ngIf="!editing.questions.length">
        {{ 'appointments.gui.questionnaires.No questions yet' | translate }}
      </p>
    </div>

    <div class="add-question-row">
      <button class="blue-btn" (click)="addQuestion()">
        ＋ {{ 'appointments.gui.questionnaires.Add Question' | translate }}
      </button>
    </div>

    <!-- Actions -->
    <div class="editor-actions">
      <button class="orange-btn" (click)="save()">{{ 'appointments.gui.questionnaires.Save' | translate }}</button>
      <button class="blue-btn" (click)="cancel()">{{ 'appointments.gui.questionnaires.Cancel' | translate }}</button>
      <span *ngIf="error" class="save-error">{{ 'appointments.gui.questionnaires.Save error' | translate }}</span>
    </div>
  </div>

  <!-- Exam-type conflict popup (item 7): an exam is already assigned to another questionnaire -->
  <div *ngIf="showConflictModal" class="print-history-popup">
    <div class="print-history-popup-body">
      <button class="print-history-popup-close" aria-label="close popup" (click)="closeConflictModal()"></button>
      <h2 class="popup-title" style="text-align: center;">
        {{ 'appointments.gui.questionnaires.conflict.Title' | translate }}
      </h2>
      <ul class="conflict-list">
        <li *ngFor="let c of examConflicts">
          {{ 'appointments.gui.questionnaires.conflict.Line' | translate:{ exam: c.examLabel, questionnaire: c.ownerName } }}
        </li>
      </ul>
      <div class="conflict-actions">
        <button class="btn-ok" (click)="replaceConflictsAndSave()">
          {{ 'appointments.gui.questionnaires.conflict.Replace' | translate }}
        </button>
        <button class="btn-cancel" (click)="removeConflictsAndSave()">
          {{ 'appointments.gui.questionnaires.conflict.Remove exams' | translate }}
        </button>
      </div>
    </div>
  </div>

</div>
